import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createShadowValidator } from './validator';

const shadowAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.shadowStyles),
  validator: createShadowValidator(),
};

export default shadowAction;
